import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ClientConcat } from '../../../../shared/client/client';
import { ClientService } from '../../../../shared/client/client.service';

@Injectable({
  providedIn: 'root'
})
export class ClientResolver {

  client: Observable<ClientConcat>;
  constructor(
    private clientService: ClientService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ClientConcat> {
    let idCLient = route.params['id'];
    return this.clientService.getClientConcat(idCLient);
  }

}
